import type { BrandConfig, BrandName } from '@gastrosoft/shared/theme';

export type { BrandConfig, BrandName };

export const brandConfigs: Record<BrandName, BrandConfig> = {
  'orda-pos': {
    name: 'orda-pos',
    appName: 'ORDA Reseller Portal',
    logo: '/logos/orda-pos-logo.svg',
    favicon: '/logos/orda-pos-favicon.svg',
    domains: ['reseller.orda-app.com', 'orda-app.com', 'localhost'],
  },
  gastrosoft: {
    name: 'gastrosoft',
    appName: 'GastroSoft Reseller Portal',
    logo: '/logos/gastrosoft-logo.svg',
    favicon: '/logos/gastrosoft-favicon.svg',
    domains: ['gastrosoft.de'],
  },
};
